import query from '../utils/grappa';
import { ARTICLES_FETCH_SIZE } from './article';
import { HOME_QUERY, CATEGORY_QUERY } from '@elevio-kb/queries';
import {
  HomePageQuery,
  HomePageQueryVariables,
  CategoryPageQuery,
  CategoryPageQueryVariables,
} from '@elevio-kb/queries/dist/types';

export async function fetchHome(languageId: string) {
  const res = await query<HomePageQuery, HomePageQueryVariables>(HOME_QUERY, {
    pageUrl: window.location.toString(),
    languageId,
    paging: {
      first: 5, // This can't be 0, the query fails
      offset: 0,
    },
  });

  return res;
}

export async function fetchCategory(categoryId: string, languageId: string) {
  const res = await query<CategoryPageQuery, CategoryPageQueryVariables>(
    CATEGORY_QUERY,
    {
      categoryId,
      pageUrl: window.location.toString(),
      languageId,
      paging: {
        first: ARTICLES_FETCH_SIZE,
        offset: 0,
      },
    }
  );

  return res;
}
